<template>
  <div>
    <label
      class="block"
      :class="[themes_labes[theme]]"
      v-if="label"
    >
      <span v-html="label"></span>
      <span v-if="required" class="obligatoire">*</span>
    </label>
    <input
      autocomplete="off"
      class="border border-grey rounded w-full p-3 mb-5 text-grey-darker leading focus:outline-none"
      v-model="url"
      :disabled="disabled"
      placeholder="http://www.youtube.com/watch?"
    />
    <iframe
      v-if="testYoutube != false"
      type="text/html"
      width="500"
      height="265"
      frameborder="0"
      class="w-full"
      allowfullscreen
      :src="videoThumb"
    ></iframe>
  </div>
</template>


<script>
export default {
  name: "sp-youtube",
  data() {
    return {
      testYoutube: false,
      videoThumb: "",
      themes: {
        default: "",
        form:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight",
        dark: "button--dark"
      },
      themes_labes: {
        default: "",
        form: "text-blue text-2sm mb-4",
        dark: "button--dark"
      }
    };
  },
  props: {
    label: String,
    url: {
      type: String,
      default: ""
    },
    theme: {
      required: false,
      type: String,
      default: ""
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    functionvalidateYoutubeUrl() {
      let videoCode = this.isYoutube(this.url);
      if (videoCode !== false) {
        this.videoThumb =
          "https://www.youtube.com/embed/" +
          videoCode +
          "?autoplay=1&enablejsapi=1";
      } else {
        this.videoThumb = "";
      }
    },

    isYoutube(url) {
      let pattern = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      let matches = url.match(pattern);
      if (matches) {
        this.testYoutube = matches[1];
      } else this.testYoutube = false;
      return this.testYoutube;
    }
  },
  watch: {
    url: function(newurl) {
      this.functionvalidateYoutubeUrl();
      this.$emit("update", newurl);
    }
  },
  created() {
    this.functionvalidateYoutubeUrl();
  }
};
</script>
